<div *ngIf="executionPromise | async; else loading">
</div>
<ng-template #loading>
  <div *ngIf="executionPromise">
    <app-loading-message [progressMessage]="progressMessage"></app-loading-message>
  </div>
</ng-template>

